import { format } from 'date-fns';

export function calculateDaysRemaining(dos: string): any {
  const dosDate: Date = new Date(dos);
  const currentDate: Date = new Date();
  const endDate: Date = new Date(dosDate);
  endDate.setDate(dosDate.getDate() + 30);

  const timeDiff: number = endDate.getTime() - currentDate.getTime();

  const daysRemaining: number = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

  return daysRemaining > 0 ? `${daysRemaining} days` : '-';
}

export const formatServiceDate = (dateOfService: string | null): string => {
  if (!dateOfService) return '-';

  const date = new Date(dateOfService);
  const offset = date.getTimezoneOffset() * 60 * 1000;
  const adjustedDate = new Date(date.valueOf() + offset);

  return format(adjustedDate, 'dd MMM, yyyy');
};
